import {useState, useEffect, useRef} from 'react'
import useAuth from '../../Users/hooks/useAuth';
import AccessInterface from '../../Users/AccessInterface';
import UserProfile from '../../Users/UserProfile';
import BookCase from '../../Books/BookCase';
import Audiobook from './Audiobook';
import Videobook from './Videobook';
import Collection from './Collection';
import { Link } from "react-router-dom";
import YourPresentations from '../../presentations/YourPresentations';
import HowToPage from './HowToPage';

const Library = () => {
    const { auth, setAuth } = useAuth();
    const [adminPage, setAdmin] = useState(false);
    const [howtoPage, setHowTo] = useState(false);
    const [creatorPage, setCreator] = useState(false);
    const [presentationsPage, setPresentations] = useState(false);
    const [userProfile, setProfile] = useState(false);
    const [message, setMessage] = useState(null)
    const [subjects, setSubjects]=useState([])
    const [subject, setSubject] = useState()
    const [languages, setLanguages] = useState()
    const [error, setError] = useState()
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    
    const itemsRef = useRef(null);

    useEffect(() => {
        const checkMobile = () => {
            const mobile = window.innerWidth < 768;
            setIsMobile(mobile);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const getSubjects = async () => {
        const token = localStorage.getItem("token");
            
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/list-books`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        }).catch(error => {
            setError("Problems with server, check later")
        });
        
        if (!response.ok) {
            setError("server problem, check later")
        };
        const json = await response.json();
        setSubjects(json)
    }

    const getLanguages = async () => {
        const token = localStorage.getItem("token");
            
        const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/subjects/list-languages`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        });
        
        if (response.ok) {
            const json = await response.json();
            setLanguages(json)
        };
    }
    
    useEffect(()=>{getSubjects(); getLanguages()},[])

    function scrollToId(itemId) {
        const frames = [ 
            { transform: "translateX(2em)"},
            { transform: "translateX(-2em)"},
            { transform: "translateX(0)"},
        ]    
        const map = getMap();
        const node = map.get(itemId);
        
        if (node) {
            node.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest'
            });
            node.animate(frames, { duration: 1500, fill: "forwards", iterations: 1 });
        }
    }
  
    function getMap() {
        if (!itemsRef.current) {
            itemsRef.current = new Map();
        }
        return itemsRef.current;
    }

    const logout = () =>{
        localStorage.removeItem("token");
        setAuth({});
    }

    if (userProfile) {
        return <UserProfile successHandler={(state) => setProfile(state)} />
    }

    if (adminPage) {
        return <AccessInterface successHandler={(state) => setAdmin(state)} />
    }

    if (creatorPage) {
        return <BookCase successHandler={(state) => setCreator(state)} />
    }
    if (presentationsPage) {
        return <YourPresentations successHandler={(state) => setPresentations(state)} />
    }
    
    if (howtoPage) {
        return <HowToPage successHandler={(state) => setHowTo(state)}  />
    }

    return (
        error ? <div className='text-3xl font-bold mx-auto p-20'>{error}</div> 
        : subject ? 
            (subject.type === "Audiobook") ? <Audiobook subject={subject} exerciseHandler={(state)=>{setSubject(state)}}/> : <Videobook subject={subject} exerciseHandler={(state)=>{setSubject(state)}}/>
        : <div className="flex flex-col min-h-screen bg-slate-50">
            {/* Elegant Header */}
            <header className="w-full bg-white border-b border-slate-200 shadow-sm sticky top-0 z-50">
                <div className="px-6 py-4">
                    <div className="flex items-center justify-between">
                        {/* Clean Brand */}
                        <Link to="/" onClick={()=>{setSubject()}} className="group">
                            <p className='text-2xl font-light tracking-tight text-slate-800 font-serif group-hover:text-slate-900 transition-colors duration-200'>
                                The Catchphraser
                            </p>
                        </Link>

                        {/* More Visible Hamburger Menu Button */}
                      <button 
    className="md:hidden p-3 rounded-lg bg-white hover:bg-slate-50 border-2 border-slate-300 transition-all duration-200 shadow-lg"
    onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
    aria-label="Menu"
>
    <div className="w-6 h-6 flex flex-col justify-between items-center">
        <span className={`w-6 h-0.5 bg-slate-700 transition-all ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
        <span className={`w-6 h-0.5 bg-slate-700 transition-all ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
        <span className={`w-6 h-0.5 bg-slate-700 transition-all ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
    </div>
</button>
                    </div>

                    {/* Mobile Menu */}
                    {mobileMenuOpen && (
                        <div className="md:hidden mt-4 py-4 border-t border-slate-200 bg-white rounded-lg shadow-lg">
                            <div className="flex flex-col gap-2">
                                {auth?.role === "ADMIN" && (
                                    <button 
                                        className="w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3"
                                        onClick={() => { setAdmin(true); setMobileMenuOpen(false); }}
                                    >
                                        <span className="text-slate-500">⚙️</span>
                                        <span>Admin</span>
                                    </button>
                                )}
                                {["CREATOR", "ADMIN"].includes(auth?.role) && (
                                    <button 
                                        className="w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3"
                                        onClick={() => { setCreator(true); setMobileMenuOpen(false); }}
                                    >
                                        <span className="text-slate-500">📖</span>
                                        <span>Creator</span>
                                    </button>
                                )}
                                 {(auth?.username && auth.username !== "guest") && (
                                <button 
                                    className="w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3"
                                    onClick={() => { setPresentations(true); setMobileMenuOpen(false); }}
                                >
                                    <span className="text-slate-500">🎯</span>
                                    {console.log(auth.username, "auth auth")}
                                    <span>Presentations</span>
                                </button>)}
                                <button 
                                    className="w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3"
                                    onClick={() => { setHowTo(true); setMobileMenuOpen(false); }}
                                >
                                    <span className="text-slate-500">ℹ️</span>
                                    <span>How-to</span>
                                </button>
                                
                                {/* User Section */}
                                {auth?.username && (
                                    <>
                                        <div className="border-t border-slate-200 mt-2 pt-3">
                                            <button 
                                                className="w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3"
                                                onClick={() => {
                                                    if (auth.username !== 'guest') {
                                                        setProfile(true);
                                                        setMobileMenuOpen(false);
                                                    } else {
                                                        setMessage('Please register!');
                                                        setTimeout(() => {setMessage(null)}, 1000);
                                                        setMobileMenuOpen(false);
                                                    }
                                                }}
                                            >
                                                <span className="text-slate-500">👤</span>
                                                <span>{auth.username}</span>
                                            </button>
                                            <button 
                                                className="w-full text-left px-4 py-3 text-slate-600 hover:bg-slate-50 rounded-lg font-medium transition-colors duration-200 flex items-center gap-3 mt-1"
                                                onClick={() => { logout(); setMobileMenuOpen(false); }}
                                            >
                                                <span className="text-slate-500">↩️</span>
                                                <span>Logout</span>
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    )}

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex md:items-center md:justify-between mt-4 md:mt-0">
                        <div className="flex flex-wrap gap-2">
                            {auth?.role === "ADMIN" && (
                                <button 
                                    className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2"
                                    onClick={() => setAdmin(true)}
                                >
                                    <span>⚙️</span>
                                    Admin
                                </button>
                            )}
                            {["CREATOR", "ADMIN"].includes(auth?.role) && (
                                <button 
                                    className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2"
                                    onClick={() => setCreator(true)}
                                >
                                    <span>📖</span>
                                    Creator
                                </button>
                            )}
                            {console.log('Auth:', auth?.username, 'Should show button:', auth?.username !== "guest") }
                            {(auth?.username && auth.username !== "guest") && (
                            <button 
                                className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2"
                                onClick={() => setPresentations(true)}
                            >
                                <span>🎯</span>
                                Presentations
                            </button>)}
                            <button 
                                className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2"
                                onClick={() => setHowTo(true)}
                            >
                                <span>ℹ️</span>
                                How-to
                            </button>
                        </div>

                        {/* Desktop User Section */}
                        {auth?.username && (
                            <div className="flex items-center gap-3 border-l border-slate-300 pl-4 ml-2">
                                <button 
                                    className='px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2'
                                    onClick={() => {
                                        if (auth.username !== 'guest') {
                                            setProfile(true)
                                        } else {
                                            setMessage('Please register!')
                                            setTimeout(() => {setMessage(null)}, 1000)
                                        }
                                    }}
                                >
                                    {message ? (
                                        <span className='text-slate-700 font-medium animate-pulse'>{message}</span>
                                    ) : (
                                        <>
                                            <span>👤</span>
                                            {auth.username}
                                        </>
                                    )}
                                </button>
                                <button 
                                    className="px-4 py-2 bg-slate-100 hover:bg-slate-200 text-slate-700 rounded-lg font-medium text-sm transition-all duration-200 border border-slate-300 hover:border-slate-400 flex items-center gap-2"
                                    onClick={logout}
                                >
                                    <span>↩️</span>
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <div className='flex-1 flex flex-col lg:flex-row'>
                {/* Languages Sidebar */}
                <div className={`lg:w-64 xl:w-72 flex-shrink-0 bg-white border-r border-slate-200 ${isMobile ? 'hidden' : 'block'}`}>
                    <div className='sticky top-20 h-[calc(100vh-5rem)] overflow-y-auto py-6 px-4'>
                        <p className='text-xl font-semibold font-sans p-3 text-slate-800 border-b border-slate-200 mb-6'>Languages</p>
                        {languages && (
                            <div className='space-y-1'>
                                {languages.map((category, i) => {
                                    let cat = category.split('_')[0]
                                    let key_value = 'index' + category
                                    
                                    const languageFlags = {
                                        'English': '🇬🇧', 'Spanish': '🇪🇸', 'French': '🇫🇷', 'German': '🇩🇪',
                                        'Italian': '🇮🇹', 'Russian': '🇷🇺', 'Chinese': '🇨🇳', 'Japanese': '🇯🇵',
                                        'Korean': '🇰🇷', 'Arabic': '🇸🇦', 'Portuguese': '🇵🇹', 'Dutch': '🇳🇱',
                                        'Greek': '🇬🇷', 'Hebrew': '🇮🇱', 'Hindi': '🇮🇳', 'Turkish': '🇹🇷',
                                        'Polish': '🇵🇱', 'Ukrainian': '🇺🇦', 'Swedish': '🇸🇪', 'Norwegian': '🇳🇴',
                                        'Danish': '🇩🇰', 'Finnish': '🇫🇮', 'Vietnamese': '🇻🇳'
                                    }
                                    
                                    const flag = languageFlags[cat] || '📚'
                                    
                                    return (
                                        <div key={key_value} className='group'>
                                            <button 
                                                className='w-full text-left px-3 py-3 text-sm font-medium text-slate-700 hover:text-slate-900 hover:bg-slate-50 rounded-lg transition-all duration-200 border border-transparent hover:border-slate-300'
                                                onClick={() => { scrollToId(category) }}
                                            >
                                                <div className="flex items-center justify-between">
                                                    <div className="flex items-center space-x-3 min-w-0 flex-1">
                                                        <span className="text-base flex-shrink-0">{flag}</span>
                                                        <span className="truncate">{cat}</span>
                                                    </div>
                                                    <svg 
                                                        className="w-3 h-3 text-slate-400 group-hover:text-slate-600 transform group-hover:translate-x-1 transition-transform" 
                                                        fill="none" 
                                                        stroke="currentColor" 
                                                        viewBox="0 0 24 24"
                                                    >
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                                    </svg>
                                                </div>
                                            </button>
                                        </div>
                                    )
                                })}
                            </div>
                        )}
                    </div>
                </div>
                
                {/* Collections */}
                <div className='flex-1 min-w-0'>
                    <div className='p-6 md:p-8 lg:p-10 space-y-8'>
                        {languages && languages.map((item, i) => {
                            var key = item + i
                            return (
                                <div key={key} 
                                    className='bg-white rounded-lg shadow-sm border border-slate-200 overflow-hidden hover:shadow-md transition-all duration-200'
                                    ref={(node) => {
                                        const map = getMap();
                                        if (node) {
                                            map.set(item, node);
                                        } else {
                                            map.delete(item);
                                        }
                                    }}>
                                    <div className='p-6 md:p-8'>
                                        <p className='text-xl md:text-2xl font-semibold font-sans text-slate-800 mb-6'>{item} Collection</p>
                                        <div className='border-t border-slate-200 pt-6'>
                                            <Collection language={item} itemHandler={(state) => setSubject(state)}/>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Library;